export default {
    loaded: ({tasks}) => tasks.loaded,
    tasks: {
        general: {
            phone: ({tasks}) => tasks.tasks ? tasks.tasks.general.phone : null,
            email: ({tasks}) => tasks.tasks ? tasks.tasks.general.email : null
        },
        daily: {
            deposit: ({tasks}) => tasks.tasks ? tasks.tasks.daily.deposit : null,
            crypto_deposit: ({tasks}) => tasks.tasks ? tasks.tasks.daily.crypto_deposit : null,
            games: ({tasks}) => tasks.tasks ? tasks.tasks.daily.games : null,
            facebook: ({tasks}) => tasks.tasks ? tasks.tasks.daily.facebook : null,
            facebook_story: ({tasks}) => tasks.tasks ? tasks.tasks.daily.facebook_story : null,
            vip_deposit: ({tasks}) => tasks.tasks ? tasks.tasks.daily.vip_deposit : null,
            tripple_deposit: ({tasks}) => tasks.tasks ? tasks.tasks.daily.tripple_deposit : null
        },
        weekly: {
            online: ({tasks}) => tasks.tasks ? tasks.tasks.weekly.online : null,
            deposits: ({tasks}) => tasks.tasks ? tasks.tasks.weekly.deposits : null
        }
    }

}